var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlassHalf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M351.856 0H32.147C13.416 0 -1.348 15.879 0.098 34.471L32.658 452.941C35.252 486.271 63.176 512 96.756 512H293.531C327.479 512 355.574 485.723 357.693 451.992L383.938 33.996C385.092 15.574 370.395 0 351.856 0ZM334.963 48L322.908 240H64.236L49.297 48H334.963ZM293.531 464H96.756C88.293 464 81.16 457.506 80.514 449.217L67.971 288H319.897L309.789 448.982C309.26 457.402 302.117 464 293.531 464Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlassHalf);
export default __webpack_public_path__ + "static/media/glass-half.6b868e288325d9e84c0342a4cab41e64.svg";
export { ForwardRef as ReactComponent };